import { EnumBase } from 'hay-core-react';
class PesquisaTipoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.pesquisa.tipo.nps',
                'main.pesquisa.tipo.csat',
            ],
        );
    }
}

const instance = new PesquisaTipoEnum();
export default instance;
